<section class="flex flex-col m-2.5 grow gap-6">
    <app-management-list-header
        [asAction]="false"
        [asSearch]="false"
        [title]="'Notification' | transloco" />

    @if (formGroup()) {
        <form
            class="flex flex-col gap-4"
            [formGroup]="formGroup()!">
            <app-input-text
                [inputFormControl]="formGroup()!.controls.title"
                [label]="'title' | transloco"
                [placeholder]="'title' | transloco" />

            <app-select
                [label]="'notificationType' | transloco"
                [options]="notificationTypeOption"
                [placeholder]="'notificationType' | transloco"
                (optionSelected)="selectNotificationType($event)" />

            <app-input-large-text
                [inputFormControl]="formGroup()!.controls.body"
                [label]="'message' | transloco"
                [placeholder]="'message' | transloco" />
        </form>
    }

    <div class="flex flex-row justify-end">
        <app-button
            [disabled]="!formGroup()?.valid"
            [icon]="['fas', 'paper-plane']"
            [label]="'send' | transloco"
            [type]="ButtonType.PRIMARY"
            (click)="sendNotification()" />
    </div>
</section>
